import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import HomePage from './pages/HomePage';
import VideoReview from './pages/VideoReview';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminProjectForm from './pages/AdminProjectForm';
import PublicProject from './pages/PublicProject';

function App() {

  return (
    <Router>
      <Routes>
        {/* Administration */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/new-project" element={<AdminProjectForm />} />

        {/* Accès aux projets (public avec contrôles admin si connecté) */}
        <Route path="/projects/:projectId" element={<PublicProject />} />

        {/* Vidéos (accès public) */}
        <Route path="/videos/:videoId" element={<VideoReview />} />

        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
